import { render, staticRenderFns } from "./roomListLinking.vue?vue&type=template&id=0a906d91&scoped=true&"
import script from "./roomListLinking.vue?vue&type=script&lang=js&"
export * from "./roomListLinking.vue?vue&type=script&lang=js&"
import style0 from "./roomListLinking.vue?vue&type=style&index=0&id=0a906d91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a906d91",
  null
  
)

export default component.exports